import { Box } from '@chakra-ui/react';
import CustomCheckbox from '../forms/CustomCheckbox';

const DataGridCheckbox = ({ value, setValue, colDef, isDisabled = false }) => {
    return (
        <Box h="full" display="flex" alignItems="center">
            <CustomCheckbox
                isChecked={value}
                onChange={(e) => colDef.editable && setValue(e.target.checked)}
                isDisabled={isDisabled}
            />
        </Box>
    );
};

export default DataGridCheckbox;
